import { ReactElement } from 'react';
import { Collapse } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

import { HasChangeOrdersAlertProps } from './types';
import {
  HasChangeOrdersAlertContainer,
  HasChangeOrdersAlertButtonAction,
} from './styles';

const HasChangeOrdersAlert = ({
  expanded,
  onRefresh,
  sx,
}: HasChangeOrdersAlertProps): ReactElement => (
  <Collapse in={expanded} timeout="auto" unmountOnExit sx={sx}>
    <HasChangeOrdersAlertContainer
      severity="info"
      variant="standard"
      icon={<InfoIcon fontSize="inherit" />}
    >
      ¿Hay cambios en la lista?{' '}
      <HasChangeOrdersAlertButtonAction
        variant="text"
        color="inherit"
        size="small"
        onClick={onRefresh}
      >
        Click aca para refrescar el listado
      </HasChangeOrdersAlertButtonAction>
    </HasChangeOrdersAlertContainer>
  </Collapse>
);

export default HasChangeOrdersAlert;
